import axios from "axios";
import { ElMessage, ElLoading, ElMessageBox } from "element-plus";
import router from "@/router";

export const $http = axios.create({
  baseURL: window.apiUrl,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

let loading;

// 添加请求拦截器
$http.interceptors.request.use(
  function (config) {
    if (config.headers.LoadMsg) {
      loading = ElLoading.service({
        lock: true,
        text: decodeURIComponent(config.headers.LoadMsg),
        background: "rgba(0, 0, 0, 0.7)",
      });
    }
    if (config.params?.Params) {
      config.params.Params = JSON.stringify(config.params.Params);
    }

    config.headers.Authorization = localStorage.getItem("token");
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

let showLogin = false; //是否提示登录框

// 添加响应拦截器
$http.interceptors.response.use(
  function (response) {
    if (loading != null) {
      loading.close();
    }
    return response;
  },
  function (error) {
    if (loading != null) {
      loading.close();
    }

    //如果response为空的，接口服务未启动
    if (error.response === undefined) {
      ElMessage({
        message: "服务器异常，请求失败！",
        grouping: true,
        type: "error",
      });
      return Promise.reject(-10);
    } else {
      //400一般错误，直接弹出提示框
      if (error.response.status === 400) {
        //如果是400错误，则监测该接口是否允许弹窗提示错误，如果允许则弹窗，不允许则返回400错误对象
        if (error.response.config.headers.ShowError) {
          ElMessage.error({
            dangerouslyUseHTMLString: true,
            message: error.response.data.msg,
            grouping: true,
          });
        } else {
          return Promise.reject(error.response);
        }
      }
      //401未授权
      else if (error.response.status == 401) {
        if (!showLogin) {
          showLogin = true;
          ElMessageBox.alert("请重新登录！", "提示", {
            type: "warning",
            confirmButtonText: "确定",
            callback: () => {
              localStorage.removeItem("token");
              showLogin = false;
              router.go(0);
            },
          });
        }
        // const tokenModelStr = localStorage.getItem("token");
        // //验证token是否存在缓存中
        // if (tokenModelStr) {
        //   if (!refreshToken) {
        //     //检查是否正在刷新token,避免同时请求刷新多个token
        //     refreshToken = true;
        //     var tokenModel = JSON.parse(tokenModelStr);
        //     axios
        //       .create()
        //       .put(
        //         $http.defaults.baseURL + "/Login",
        //         {},
        //         {
        //           headers: {
        //             token: tokenModel?.token,
        //             refToken: tokenModel?.refToken,
        //           },
        //         }
        //       )
        //       .then((res) => {
        //         if (res.status == 200) {
        //           //刷新token成功，直接返回正确的token，继续执行接口
        //           localStorage.setItem("token", JSON.stringify(res.data));
        //           refreshToken = false;
        //           error.config.headers.Authorization =
        //             "Bearer " + res.data.token;
        //           return $http(error.config);
        //         }
        //       })
        //       .catch((err) => {
        //         //如果刷新token接口返回401，表示token已经彻底过期，提示重新登录
        //         if (err.response.status == 401) {
        //           ElMessageBox.alert("请重新登录", "提示", {
        //             confirmButtonText: "OK",
        //             callback: () => {
        //               refreshToken = false;
        //               localStorage.removeItem("token");
        //               router.go(0);
        //             },
        //           });
        //         }
        //       });
        //   } else {
        //     //如果正在刷新token,则轮询监测刷新token接口是否已返回
        //     let refFunc = setInterval(() => {
        //       //循环监测token是否刷新完成
        //       if (!refreshToken) {
        //         //如果刷新token接口已返回，则继续调用接口
        //         clearInterval(refFunc);
        //         error.config.headers.Authorization =
        //           "Bearer " + JSON.parse(localStorage.getItem("token"))?.token;
        //         return $http(error.config);
        //       }
        //     }, 500);
        //   }
        // } else {
        //   //如果取不到token，则提示登录
        //   ElMessageBox.alert("请重新登录！", "提示", {
        //     type: "warning",
        //     confirmButtonText: "确定",
        //     callback: () => {
        //       localStorage.removeItem("token");
        //       router.go(0);
        //     },
        //   });
        // }
      } else if (error.response.status == 500) {
        if (error.response.config.headers.ShowError) {
          ElMessage({
            message: "系统异常，请求失败！",
            grouping: true,
            type: "error",
          });
          return Promise.reject(500);
        } else {
          return Promise.reject(error.response);
        }
      }
    }
  }
);

//加载动画及错误信息提示    1：表示显示加载动画，不提示错误信息   2：不显示加载动画，提示错误信息  3：表示即显示加载动画，又错误提示
export const buildHeaders = (type, loadMsg = "正在提交数据，请稍后……") => {
  let data = {};
  if (type === 1) {
    //表示显示加载动画，不提示错误信息
    data = {
      LoadMsg: encodeURIComponent(loadMsg),
    };
  } else if (type === 2) {
    //不显示加载动画，提示错误信息
    data = {
      ShowError: true,
    };
  } else if (type === 3) {
    //表示即显示加载动画，又错误提示
    data = {
      LoadMsg: encodeURIComponent(loadMsg),
      ShowError: true,
    };
  }
  return data;
};
